export default __webpack_public_path__ + "static/media/menu35.f00edd0a.svg";